export default {
    // 账号：pingtai2
    // 密码：123456
    // apiUrl: 'http://192.168.0.199:96', // 本地
    // apiUrl: 'https://test.suyuan02.hulianzaowu.work', // 测试
    // apiUrl: 'https://suyuan.hulianzaowu.com', // 线上
    apiUrl: `${location.origin}`, // 自动获取
}
